export const renderCurrentJob = (user) => {
    const formatNames = values =>
        values?.split(/[_-\s]/).map(v => v[0]?.toUpperCase() + v.slice(1)).join(' ');


    let fetchCurrentJob;
    if (user?.experiences?.length && Array.isArray(user.experiences)) {
        fetchCurrentJob = user.experiences.filter(usr => usr.isOngoing).reverse()[0]
    }

    return fetchCurrentJob ? formatNames(fetchCurrentJob.jobTitle) : null
}